export enum ModalAnimationDirections {
  Up = 'up',
  Down = 'down',
}
export interface IStyledModalProps {
  slideDirection?: ModalAnimationDirections;
  isFieldInfo?: boolean;
}
